// src/stores/mobileStore.ts
import { create } from 'zustand';
import type { StateCreator } from 'zustand';

// This new mode is the key to fixing the final transition
type AppMode = 'intro' | 'answering_questions' | 'transitioning_to_features' | 'viewing_features' | 'showing_stories_card' | 'viewing_headlines';

interface AppState {
  appMode: AppMode;
  activeSection: number | null;
  isInteractionReady: boolean;
  isNavigating: boolean;
  actions: {
    setAppMode: (mode: AppMode) => void;
    setNavigating: (isNav: boolean) => void;
    setSectionFromButton: (section: number | null) => void;
    setSectionFromScroll: (section: number) => void;
    handleNextOnLastQuestion: (sectionStarts: number[], vh: number, isMobile: boolean) => void;
    completeTransition: () => void;
  };
}

const createAppState: StateCreator<AppState> = (set, get) => ({
  appMode: 'intro',
  activeSection: 0,
  isInteractionReady: true,
  isNavigating: false,

  actions: {
    setNavigating: (isNav) => set({ isNavigating: isNav }),
    setAppMode: (mode) => set({ appMode: mode }),
    
    setSectionFromButton: (section) => {
      set({ activeSection: section });
    },
    
    setSectionFromScroll: (section) => {
      if (get().isNavigating || get().appMode === 'transitioning_to_features') {
        return;
      }
      set({ activeSection: section });
    },
    
    handleNextOnLastQuestion: (sectionStartVhValues: number[], viewportHeight: number, isMobile: boolean) => {
      set({ appMode: 'transitioning_to_features', activeSection: 12, isInteractionReady: false });
      
      if (!isMobile) {
        const sectionTopPx = (sectionStartVhValues[12] / 100) * viewportHeight;
        window.scrollTo({ top: sectionTopPx, behavior: 'auto' });
      }
    },
    
    completeTransition: () => {
      set({ appMode: 'viewing_features' });
      setTimeout(() => set({ isInteractionReady: true }), 150);
    },
  },
});

export const useMobileAppStore = create<AppState>(createAppState);